import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable()
export class DisciplineService {
  private resourceUrl = environment.apiUrl + 'disciplines';

  constructor(private http: HttpClient) {}

  getAll(separated: boolean = false): Observable<HttpResponse<any[]>> {
    const options: HttpParams = new HttpParams();
    options.set('separated', separated + '');
    return this.http.get<any[]>(this.resourceUrl + '/all', {params: options, observe: 'response'});
  }
  getMine(separated: boolean = false): Observable<HttpResponse<any[]>> {
    const options: HttpParams = new HttpParams();
    options.set('separated', separated + '');
    return this.http.get<any[]>(this.resourceUrl + '/mine', {params: options, observe: 'response'});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/discipline.service.ts